<div class="dialog__container payment-dialog">
  <div class="dialog__header">
    <span>{{ modalTitle | translate }}</span>
  </div>

  <div class="dialog__content">
    <div class="dialog__input-container">
      <app-form-input
        [label]="'webPos.VoucherCode' | translate"
        [value]="voucherCode"
        [disabled]="hasPresetVoucherCode"
        (valueChange)="onVoucherCodeChange($event)"
      ></app-form-input>
      <app-action-button *ngIf="!hasPresetVoucherCode"
        [buttonSize]="ActionButtonSize.Small" [buttonType]="ActionButtonType.Confirm"
        [disabled]="!voucherCode || isCheckingVoucherStatus" (clicked)="loadVoucherStatus()">
        {{ 'webPos.Search' | translate }}
      </app-action-button>
    </div>

      <div *ngIf="isCheckingVoucherStatus" class="dialog__label mb-2 voucher-status">
        <span>{{ 'webPos.Voucher.CheckingStatus' | translate }}</span>
      </div>

      <div
        *ngIf="!isCheckingVoucherStatus && voucherStatusItem"
        class="dialog__label mb-2 voucher-status"
      >
        <span>
          {{ 'webPos.Voucher.VoucherValueLeft' | translate }}:
          {{ voucherStatusItem.voucherCurrency }} {{ voucherStatusItem.voucherPrice }}
        </span>
      </div>

      <div
        *ngIf="!isCheckingVoucherStatus && voucherStatusMessage"
        class="dialog__label mb-2 voucher-status-error"
      >
        <span>{{ voucherStatusMessage }}</span>
      </div>

    @if (amountToPay !== null && !isReturn) {
    <div class="dialog__label mb-2">
      <span>{{ amountToPayFormatted }}</span>
    </div>
    }

    <ng-container [formGroup]="confirmForm">
      <input type="hidden" formControlName="amountToPay" />
    </ng-container>
  </div>

  <div class="dialog__footer">
    <div class="dialog__button-container">
      <app-action-button
        [buttonSize]="ActionButtonSize.Small"
        [buttonType]="ActionButtonType.Cancel"
        (clicked)="onCancel()"
      >
        {{ 'webPos.Cancel' | translate }}
      </app-action-button>
    </div>
    <div class="dialog__button-container">
      <app-action-button
        [buttonSize]="ActionButtonSize.Small"
        [buttonType]="ActionButtonType.Confirm"
          [disabled]="confirmForm.invalid || !voucherValid || isCheckingVoucherStatus"
        (clicked)="onConfirm()"
      >
        {{ data?.isReturn ? ('webPos.Return' | translate) : ('webPos.Payment' | translate) }}
      </app-action-button>
    </div>
  </div>
</div>
